import React from 'react';
import { useAccessibility } from '../context/AccessibilityContext';
import { useLanguage } from '../context/LanguageContext';

const AccessibilityButton: React.FC = () => {
  const { toggleAccessibilityPanel, isAccessibilityPanelOpen } = useAccessibility();
  const { t } = useLanguage();

  return (
    <button
      onClick={toggleAccessibilityPanel}
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 10000,
        width: '56px',
        height: '56px',
        backgroundColor: isAccessibilityPanelOpen ? '#1d4ed8' : '#2563eb',
        color: 'white',
        borderRadius: '50%',
        border: 'none',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        transform: isAccessibilityPanelOpen ? 'scale(1.1)' : 'scale(1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#1d4ed8';
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
      }}
      onMouseLeave={(e) => {
        if (!isAccessibilityPanelOpen) {
          e.currentTarget.style.backgroundColor = '#2563eb';
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
        }
      }}
      aria-label={t('accessibility.openPanel')}
      title={t('accessibility.openPanel')}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        style={{ width: '24px', height: '24px' }}
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
        aria-hidden="true"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" 
        />
      </svg>
      
      {/* Indicator pentru panel deschis */}
      {isAccessibilityPanelOpen && (
        <div 
          style={{
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            width: '12px',
            height: '12px',
            backgroundColor: '#facc15',
            borderRadius: '50%',
            animation: 'pulse 1.5s infinite'
          }}
        />
      )}
    </button>
  );
};

export default AccessibilityButton; 